<template>
  <!-- 账号中心 -->
  <div id="personalCenter">
    <div v-if="userId || wxgenerateid">
      <div class="cellBox">
        <!-- <van-cell title="账号信息" icon="friends-o" is-link @click="openPopup('账号信息')" />
        <van-cell title="重置密码" icon="closed-eye" is-link @click="openPopup('重置密码')" />
        <van-cell title="更换手机" icon="phone-o" is-link @click="openPopup('更换手机')" /> -->
        <!-- <van-cell title="意见反馈" icon="comment-o" is-link @click="openPopup('意见反馈')" /> -->

        <van-cell
          title="我的账号"
          :icon="icon.myAccount"
          is-link
          @click="openPopup('我的账号')"
        />
        <van-cell
          title="我的订单"
          :icon="icon.myOrder"
          is-link
          @click="openPopup('我的订单')"
        />
        <van-cell
          title="我的发票"
          :icon="icon.myReceipt"
          is-link
          @click="openPopup('我的发票')"
        />
        <van-cell
          title="我的协议"
          :icon="icon.myAgree"
          is-link
          @click="openPopup('我的合同')"
        />
        <!-- 提示语 -->
        <div>
          <van-notice-bar wrapable :scrollable="false">
            <h4>特别提示</h4>
            <p v-if="isWX == '1'">
              请及时关注微信公众号“众智云擎税法检索”, 即时精准获取税法文件智能推送。
            </p>
            <p v-else>
              请及时关注微信公众号“众智云擎税法检索”, 点击“云擎中心”按钮进入“文件提醒”, 即时精准获取税法文件智能推送。
            </p>
          </van-notice-bar>
          <p style="padding-top: 37px; text-align: center">
            <img :src="gzhewm" alt="" style="width: 146px" />
          </p>
        </div>
      </div>
      <login ref="alertModel"></login>
      <!-- 账号信息 -->
      <van-popup
        v-model="showAccMsg"
        position="bottom"
        :style="{ height: '32%' }"
        get-container="body"
      >
        <van-divider :style="{ fontSize: '18px', marginTop: '40px' }">
          账号信息
        </van-divider>
        <div
          class="acc"
          style="line-height: 40px; margin: 0 30px; font-size: 18px"
        >
          账号：{{ userId }}
        </div>
        <div
          class="acc"
          style="line-height: 40px; margin: 0 30px; font-size: 18px"
        >
          手机：{{ phone | mobileFilter }}
        </div>
      </van-popup>
      <!-- 修改手机号码 旧手机号码 -->
      <van-popup
        v-model="showOldPhonePopup"
        round
        position="bottom"
        closeable
        close-icon="close"
        @open="openOldPhonePopup"
        get-container="body"
      >
        <div class="loginContent1" style="margin: 16px 0px 20px">
          <div class="content" style="padding: 10px 20px 20px">
            <div
              class="title titleStyleAll"
              style="
                font-weight: 600;
                text-align: center;
                margin-bottom: 28px;
                font-size: 18px;
              "
            >
              更换手机号码
            </div>
            <van-steps :active="activePhone">
              <van-step>验证身份</van-step>
              <van-step>修改手机</van-step>
              <van-step>完成</van-step>
            </van-steps>
            <div style="margin-top: 20px; font-size: 0.32rem; color: #715641">
              为确认是您本人操作，请完成以下验证
            </div>
            <div style="margin-top: 30px; font-size: 0.32rem; color: #715641">
              手机号码：{{ phone | mobileFilter }}
            </div>
            <van-cell-group>
              <van-field
                v-model="oldCode"
                center
                clearable
                type="number"
                maxlength="6"
                placeholder="请输入短信验证码"
                @blur="changeCode"
                :error-message="errMsg.oldcode"
              >
                <template #button>
                  <van-button
                    :disabled="disabled"
                    size="small"
                    type="info"
                    style="
                      background-color: #ccc;
                      color: #fff;
                      border: 1px solid transparent;
                    "
                    @click="sendcode(1)"
                    >{{ btntxt }}</van-button
                  >
                </template>
              </van-field>
            </van-cell-group>
            <div style="margin-top: 30px" @click="beforeOldPhoneClose">
              <van-button block type="info" style="border-radius: 30px"
                >确定</van-button
              >
            </div>
          </div>
        </div>
      </van-popup>
      <!-- 修改手机号码 新手机号码 -->
      <van-popup
        v-model="showNewPhonePopup"
        round
        position="bottom"
        closeable
        close-icon="close"
        @open="openNewPhonePopup"
        get-container="body"
      >
        <div class="loginContent1" style="margin: 16px 0px 20px">
          <div class="content" style="padding: 10px 20px 20px">
            <div
              class="title titleStyleAll"
              style="
                font-weight: 600;
                text-align: center;
                margin-bottom: 28px;
                font-size: 18px;
              "
            >
              更换手机号码
            </div>
            <van-steps :active="activePhone">
              <van-step>验证身份</van-step>
              <van-step>修改手机</van-step>
              <van-step>完成</van-step>
            </van-steps>
            <div style="margin-top: 20px; font-size: 0.32rem; color: #715641">
              请输入更换后的手机号码，进行验证
            </div>
            <van-cell-group>
              <van-field
                v-model="newMoblie"
                center
                clearable
                type="number"
                maxlength="11"
                placeholder="请输入11位手机号码"
                @blur="checkNewMobile"
                :error-message="errMsg.newMobile"
              />
              <van-field
                v-model="newCode"
                center
                clearable
                type="number"
                maxlength="6"
                placeholder="请输入短信验证码"
                @blur="changeCodeNew"
                :error-message="errMsg.newcode"
              >
                <template #button>
                  <van-button
                    :disabled="disabled"
                    size="small"
                    type="info"
                    style="
                      background-color: #ccc;
                      color: #fff;
                      border: 1px solid transparent;
                    "
                    @click="sendcode(2)"
                    >{{ btntxt }}</van-button
                  >
                </template>
              </van-field>
            </van-cell-group>
            <div style="margin-top: 30px" @click="beforeNewPhoneClose">
              <van-button block type="info" style="border-radius: 30px"
                >确定</van-button
              >
            </div>
          </div>
        </div>
      </van-popup>
      <!-- 意见反馈弹框 -->
      <van-popup
        v-model="feedBack"
        closeable
        position="top"
        :style="{ height: '100%' }"
      >
        <van-divider :style="{ fontSize: '18px', marginTop: '40px' }">
          意见反馈
        </van-divider>
        <div class="feed-back-box">
          <div style="height: 100%; border: 1px solid #ccc">
            <van-field
              v-model="feedBackMessage"
              rows="18"
              autosize
              type="textarea"
              maxlength="360"
              placeholder="请输入意见/反馈内容"
            />
          </div>
        </div>
        <div class="btn-buju">
          <van-button
            style="width: 30%; border-radius: 30px; height: 40px"
            type="default"
            @click="clocsFeed"
            >取消</van-button
          >
          <van-button
            style="width: 30%; border-radius: 30px; height: 40px"
            type="info"
            @click="confirmFeedBack"
            >确定</van-button
          >
        </div>
      </van-popup>
    </div>
    <!-- <div v-else class="noDatas">请先登录</div> -->
  </div>
</template>

<script>
import Login from "@/components/common/login";
import { getSMSFrom } from "@/utils/lib/tools";
import TripleDES from "@/utils/lib/crypto.js";

export default {
  data() {
    return {
      // 公众号二维码
      gzhewm: require("../../assets/indexImg/gzhewm.jpg"),
      showAccMsg: false, // 账号信息
      showOldPhonePopup: false, // 更换手机 旧手机号码
      showNewPhonePopup: false, // 更换手机 新手机号码
      feedBack: false, // 意见反馈
      feedBackMessage: "", // 意见反馈内容
      btntxt: "发送验证码",
      disabled: false, // 禁用发送验证码按钮
      time: 0, // 倒计时
      pattern: /^1[3456789]\d{9}$/, // 手机号码验证
      oldMoblie: "", // 旧手机号码
      oldCode: "", // 验证旧手机号码的验证码
      newMoblie: "", // 新手机号码
      newCode: "", // 验证新手机号码的验证码
      errMsg: {
        oldcode: "", // 验证码
        newcode: "",
        newMobile: "", // 新手机号码
      },
      activePhone: 0, // 步骤条
      isWX: Number(localStorage.getItem("WX_VERSION")),
      icon: {
        myAccount: require("../../assets/mine/mine.png"),
        myOrder: require("../../assets/mine/indent.png"),
        myReceipt: require("../../assets/mine/bill.png"),
        myAgree: require("../../assets/mine/agreement.png")
      }
    };
  },
  components: {
    Login,
  },
  computed: {
    wxgenerateid() {
      return this.$store.state.user.wxgenerateid;
    },
    userId() {
      return this.$store.state.user.userId;
    },
    phone() {
      return this.$store.state.user.mobileNum;
    },
    accounttype() {
      return this.$store.state.user.accounttype;
    },
    wxunionid() {
      return sessionStorage.getItem("wxunionid");
    },
  },
  methods: {
    openPopup(item) {
      if (this.userId || this.wxgenerateid) {
        if (item === "账号信息") {
          this.showAccMsg = true;
        } else if (item === "重置密码") {
          this.$refs.alertModel.changeResetPassword(true);
        } else if (item === "更换手机") {
          this.showOldPhonePopup = true;
        } else if (item === "意见反馈") {
          this.feedBack = true;
          this.feedBackMessage = "";
        } else if (item === "我的账号") {
          this.$router.push("myPrivilege");
        } else if (item === "会员续费") {
          this.$router.push("xuFeiPage");
        } else if (item === "我的订单") {
          this.$router.push("myOrder");
        } else if (item === "我的发票") {
          this.$router.push("myInvoice");
        } else if (item === "我的合同") {
          this.$router.push("myContract");
        }
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先登录",
          duration: 5000,
        });
      }
    },
    // 验证申请试用验证码
    changeCode() {
      if (!this.oldCode) {
        this.errMsg.oldcode = "请输入验证码";
        return false;
      } else {
        this.errMsg.oldcode = "";
      }
    },
    changeCodeNew() {
      if (!this.newCode) {
        this.errMsg.newcode = "请输入验证码";
        return false;
      } else {
        this.errMsg.newcode = "";
      }
    },
    // 验证新手机号码
    checkNewMobile() {
      if (!this.newMoblie) {
        this.errMsg.newMobile = "请输入手机号码";
        return false;
      } else if (!this.pattern.test(this.newMoblie)) {
        this.errMsg.newMobile = "手机号码输入有误，请重新输入";
        return false;
      } else {
        this.errMsg.newMobile = "";
        return true;
      }
    },
    // 关闭验证旧手机号弹框之前
    beforeOldPhoneClose() {
      if (!this.phone || !this.oldCode) {
        this.changeCode();
        this.showOldPhonePopup = true;
      } else {
        this.$http
          .reqRegCheckSmsCode(
            this.phone,
            this.oldCode,
            getSMSFrom.SMS_CODE_TYPE_OLD_PHONE
          )
          .then((response) => {
            console.log("resp==>", response);
            if (response.rtncode === 1) {
              if (response.rltcode === 1) {
                this.showNewPhonePopup = true;
                this.showOldPhonePopup = false;
                this.activePhone = 1;
              } else {
                this.$notify({ message: response.rltdesc, duration: 5000 });
                this.showOldPhonePopup = true;
              }
            } else {
              this.$notify({ message: response.rtndesc, duration: 5000 });
              this.showOldPhonePopup = true;
            }
          })
          .catch((err) => {
            this.$notify({ message: err.message, duration: 5000 });
            this.showOldPhonePopup = true;
          });
      }
    },
    // 关闭新手机号码弹框之前
    beforeNewPhoneClose() {
      if (!this.newMoblie || !this.newCode) {
        this.checkNewMobile();
        this.changeCodeNew();
        this.showNewPhonePopup = true;
      } else {
        this.$http
          .reqRegCheckSmsCode(
            this.newMoblie,
            this.newCode,
            getSMSFrom.SMS_CODE_TYPE_NEW_PHONE
          )
          .then((response) => {
            console.log("resp==>", response);
            if (response.rtncode === 1) {
              if (response.rltcode === 1) {
                // 修改手机号码
                let params = {
                  mobilenum_old: this.phone,
                  smscode_old: this.oldCode,
                  mobilenum_new: this.newMoblie,
                  smscode_new: this.newCode,
                };
                console.log("params", params);
                this.$http
                  .reqMobileUpdate(params)
                  .then((resp) => {
                    if (resp.rtncode === 1) {
                      if (resp.rltcode === 1) {
                        sessionStorage.setItem("phone", this.newMoblie);
                        this.$store.commit("user/setMobileNum", this.newMoblie);
                        let data = TripleDES.decode(
                          "token",
                          JSON.parse(this.$cookie.get("cookieObj"))
                        );
                        data.phone = this.newMoblie;
                        this.$cookie.set(
                          "cookieObj",
                          JSON.stringify(TripleDES.encode("token", data)),
                          4
                        );
                        this.$notify({
                          color: "#fff",
                          background: "#F27852",
                          message: "手机号码更换成功",
                          duration: 5000,
                        });
                        this.showNewPhonePopup = false;
                      } else {
                        this.$notify({ message: resp.rltdesc, duration: 5000 });
                        this.showNewPhonePopup = false;
                      }
                    } else {
                      this.$notify({ message: resp.rtndesc, duration: 5000 });
                      this.showNewPhonePopup = false;
                    }
                  })
                  .catch((err) => {
                    this.$notify({ message: err.message, duration: 5000 });
                    this.showNewPhonePopup = true;
                  });
              } else {
                this.$notify({ message: response.rltdesc, duration: 5000 });
                this.showNewPhonePopup = true;
              }
            } else {
              this.$notify({ message: response.rtndesc, duration: 5000 });
              this.showNewPhonePopup = true;
            }
          })
          .catch((err) => {
            this.$notify({ message: err.message, duration: 5000 });
            this.showNewPhonePopup = true;
          });
      }
    },
    // 点击发送验证码
    sendcode(num) {
      if (num === 1) {
        // 验证身份  旧手机号码
        this.$http
          .reqSmsCode({
            mobilenum: this.phone,
            reqsrc: getSMSFrom.SMS_CODE_TYPE_OLD_PHONE,
          })
          .then((response) => {
            console.log("response发送验证码-旧手机号", response);
            if (response.rtncode === 1) {
              if (response.rltcode === 1) {
                this.$notify({
                  color: "#fff",
                  background: "#F27852",
                  message: "验证码发送成功",
                  duration: 5000,
                });
                this.time = 60;
                this.disabled = true;
                this.timer();
              } else {
                this.$notify({ message: response.rltdesc, duration: 5000 });
              }
            } else {
              this.$notify({ message: response.rtndesc, duration: 5000 });
            }
          })
          .catch((err) => {
            this.$notify({ message: err.message, duration: 5000 });
          });
      } else if (num === 2) {
        // 更换手机号码  新手机号码
        if (this.newMoblie && /^1[3456789]\d{9}$/.test(this.newMoblie)) {
          this.$http
            .reqSmsCode({
              mobilenum: this.newMoblie,
              reqsrc: getSMSFrom.SMS_CODE_TYPE_NEW_PHONE,
            })
            .then((response) => {
              console.log("response发送验证码-新手机号", response);
              if (response.rtncode === 1) {
                if (response.rltcode === 1) {
                  this.$notify({
                    color: "#fff",
                    background: "#F27852",
                    message: "验证码发送成功",
                    duration: 5000,
                  });
                  this.time = 60;
                  this.disabled = true;
                  this.timer();
                } else {
                  this.$notify({ message: response.rltdesc, duration: 5000 });
                }
              } else {
                this.$notify({ message: response.rtndesc, duration: 5000 });
              }
            })
            .catch((err) => {
              this.$notify({ message: err.message, duration: 5000 });
            });
        }
      }
    },
    // 打开验证身份弹框
    openOldPhonePopup() {
      this.oldCode = "";
      this.newMoblie = "";
      this.newCode = "";
      this.time = 0;
      this.btntxt = "获取验证码";
      this.disabled = false;
      this.activePhone = 0;
    },
    // 打开新手机号码弹框
    openNewPhonePopup() {
      this.newMoblie = "";
      this.newCode = "";
      this.time = 0;
      this.btntxt = "获取验证码";
      this.disabled = false;
      this.activePhone = 1;
    },
    // 关闭意见反馈弹框
    clocsFeed() {
      this.feedBack = false;
      this.feedBackMessage = "";
    },
    // 点击意见反馈弹框里的确定按钮
    confirmFeedBack() {
      if (this.feedBackMessage) {
        let params = {
          suggestions: this.feedBackMessage,
        };
        this.$http
          .reqCreateFeedBack(params)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.$notify({
                  color: "#fff",
                  background: "#F27852",
                  message: "意见反馈成功",
                  duration: 5000,
                });
                this.feedBack = false;
              } else {
                this.feedBack = false;
              }
            } else {
              this.feedBack = false;
            }
          })
          .catch(() => {
            this.feedBack = false;
          });
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请输入意见/反馈内容",
          duration: 5000,
        });
      }
    },
    // 验证码的倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
  },
  // 过滤电话号码
  filters: {
    mobileFilter(val) {
      let reg = /^(.{3}).*(.{4})$/;
      if (val) {
        return val.replace(reg, "$1****$2");
      }
      // return val.replace(reg,'$1****$2')
    },
  },
};
</script>

<style lang="less" scoped>
#personalCenter {
  .cellBox /deep/.van-cell {
    .van-cell__title {
      // padding-bottom: 0px;
      box-sizing: border-box;
      span {
        color: #000000;
        margin-left: 6px;
      }
    }
  }
  .cellBox /deep/.van-cell--clickable:active {
    background-color: #fff;
  }
  .cellBox /deep/.van-cell:not(:last-child)::after {
    border-bottom: none;
  }
  .feed-back-box {
    padding: 0 20px 20px;
    box-sizing: border-box;
    height: 70%;
  }
  .btn-buju {
    display: flex;
    justify-content: space-between;
    &:before,
    &:after {
      content: "";
      display: block;
    }
  }
}
</style>
<style lang="less">
.loginContent1 .van-cell {
  border: 1px solid #ededef;
  margin-top: 20px;
  border-radius: 6px;
  min-height: 60px;
}
.van-popup--bottom.van-popup--round {
  border-radius: 10px 10px 0 0;
}
.loginContent1 .van-cell:not(:last-child)::after {
  border-bottom: none;
}
.van-field__control {
  font-size: 12px;
}
</style>
